import * as t from 'ts-schema';
import { makeFrameworkTypesQuickFetchKey, makeFrameworkTypesFetchUrl } from './cacheKeys';
import { withQuickFetch } from './withQuickFetch';
import { inboundDbObjectTypeSchema } from 'inbound-db-meta-service-client/InboundDbMeta-Service/schema';
import { getAllEnabledObjectTypeDefinitionsForPortalRpc } from '../__generated__/chirp/com/hubspot/blueprint/customer/object/type/rpc/CustomerObjectTypeRpc';

/**
 * A framework type definition as returned by getObjects/getEvents. This is an
 * alias for the REST InboundDbObjectType: the objects family is fetched via
 * CHIRP but its response is mapped back to the REST shape (see
 * mapChirpToRestObject) so downstream consumers stay compatible regardless of
 * the transport used to fetch the data.
 */

// Temporary bridge from the generated CHIRP InboundDbObjectType type to the REST
// InboundDbObjectType type. They differ only on `visibility` and `status`: the
// CHIRP type marks them as constant-name enums (e.g. CUSTOMER_FACING/LIVE), but at
// runtime CHIRP already sends the REST display strings (e.g. "Customer-facing"/
// "Live"), so a cast is enough and no value conversion is needed.
const mapChirpToRestObject = chirpObject => {
  if (!t.validate(inboundDbObjectTypeSchema, chirpObject)) {
    console.warn('[fdsr] CHIRP object drifted from InboundDbObjectType', chirpObject);
  }
  return chirpObject;
};
export const fetchFrameworkTypes = ({
  family,
  httpClient,
  rpcClient
}) => withQuickFetch({
  requestName: makeFrameworkTypesQuickFetchKey({
    family
  }),
  baseFetch: () => family === 'objects' ? rpcClient.call(getAllEnabledObjectTypeDefinitionsForPortalRpc, {
    request: {}
  }).then(data => data.enabledObjectTypeDefinitions.map(mapChirpToRestObject)) : httpClient.get(makeFrameworkTypesFetchUrl({
    family
  }))
});